<template>
  <section class="hero is-info is-fullheight">
    <div class="hero-head">
      <nav class="navbar">
        <div class="container">
          <div class="navbar-brand">
            <a
              class="navbar-item"
              href="/"
            >
              <img
                src="https://placehold.it/110x30"
                alt="Logo"
              >
            </a>
          </div>
        </div>
      </nav>
    </div>

    <div class="hero-body">
      <div class="container has-text-centered">
        <div class="column is-6 is-offset-3">
          <h1 class="title">
            Coming Soon
          </h1>
          <h2 class="subtitle">
            $this is the best software platform for running an internet business. We handle billions of dollars every year for forward-thinking businesses around the world.
          </h2>
          <div class="box newsletter-subscription">
            <b-field grouped>
              <b-input
                v-model="form.email"
                type="text"
                placeholder="Enter your email"
                size="is-medium"
                expanded
                autofocus=""
              />

              <p class="control">
                <b-button
                  class="button is-info"
                  size="is-medium"
                >
                  Notify Me
                </b-button>
              </p>
            </b-field>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapActions } from 'vuex'
import { required, email } from 'vuelidate/lib/validators'

export default {
  data () {
    return {
      form: {
        email: ''
      }
    }
  },
  validations: {
    form: {
      email: { required, email }
    }
  },
  methods: {
    ...mapActions({
      login: 'auth/login'
    }),
    onSubmit () {
      this.login(this.form).then(() => this.$router.push({path: '/'})).catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
  @import url("https://fonts.googleapis.com/css?family=Kaushan+Script");

  .hero.is-info {
    background: linear-gradient(
        rgba(0, 0, 0, 0.5),
        rgba(0, 0, 0, 0.5)
      ), url('https://unsplash.it/1200/900?random') no-repeat center center fixed;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
  }

  .hero .nav, .hero.is-success .nav {
    -webkit-box-shadow: none;
    box-shadow: none;
  }

  .hero .title {
    font-family: 'Kaushan Script', sans-serif;
    transform: rotate(-5deg);
    font-size: 5rem;
    color: whitesmoke;
  }

  .hero .subtitle {
    padding: 3rem 0;
    line-height: 1.5;
    color: whitesmoke;
  }

  .newsletter-subscription.box {
    .field {
      padding-bottom: 0; 
    }
  }
</style>
